<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <div id="localInstallationMain">
          <project-asset
            v-on:project-changed="onProjectChange"
            v-on:vessel-changed="onVesselChange"
          ></project-asset>
          <v-card id="localInstallationCard">
            <v-card-title
              id="tableTitle"
              class="primary--text"
              style="font-size: 1.5em; padding: 20px"
              >{{ $t("nav.localInstallation") }}</v-card-title
            >
            <v-data-table
              id="localInstallationTable"
              :headers="headers"
              :items="items"
              :items-per-page="-1" disable-pagination 
              class="elevation-0"
            >
              <template slot="item" slot-scope="props">
                <tr>
                  <td style="text-align: left">{{ props.item.computerName }}</td>
                  
                  <td style="text-align: left">
                     {{ props.item.projectId | projectName(projectsMap) }}
                  </td>
                  <td style="text-align: left">
                    {{ props.item.vesselId | vesselName(vesselsMap) }}
                  </td>
                  <td style="text-align: left">
                    <span v-if="props.item.assignmentStart != null">{{
                      dateMixin(props.item.assignmentStart)
                    }}</span>
                  </td>
                  <td style="text-align: left">
                    <span v-if="props.item.assignmentEnd != null">{{
                      dateMixin(props.item.assignmentEnd)
                    }}</span>
                  </td>
                  <td>
                    <v-btn
                      id="btnDel"
                      color="primary"
                      x-small
                      fab
                      outlined
                      elevation="1"
                      :disabled="props.item.active === false"
                      @click="deleteItemConfirm(props.item)"
                    >
                      <v-icon small color="primary">
                        disabled_by_default
                      </v-icon> </v-btn
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-dialog v-model="dialog" max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-form @submit.prevent="submit" ref="form">
                  <v-container>
                    <v-row>
                      <v-col cols="12" >
                    <v-select
                    :rules="[
                            () => !!editedItem.computerId || requiredMessage
                          ]"
                    required
                    :items="computers"
                    item-text="computerName"
                    item-value="id"
                    clearable
                    v-model="editedItem.computerId"
                    >
                    <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('localInstallation.computerId') }}
                          </template>
                    </v-select>
                    </v-col>
                 </v-row>
                 <v-row>
                     <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.projectId || requiredMessage
                          ]"
                          required
                          :items="projects"
                          item-text="Name"
                          item-value="Id"
                          v-model="editedItem.projectId"
                          @change="onDlgProjectChange"
                          ><template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('common.projectName') }}
                          </template>
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          :rules="[
                            () => !!editedItem.vesselId || requiredMessage
                          ]"
                          required
                          class="form-control"
                          :items="projectVessels"
                          item-text="Name"
                          item-value="Id"
                          v-model="editedItem.vesselId"
                          :readonly="editedIndex != -1"
                        >
                          <template v-slot:label>
                            <v-icon color="red" x-small>mdi-asterisk</v-icon>
                            {{ $t('nav.vessel') }}
                          </template>
                        </v-select></v-col
                      >
                    </v-row>
                  </v-container>
                  </v-form>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">{{
                    $t("common.cancel")
                  }}</v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="save"
                    :disabled="!formIsValid"
                    >{{ $t("common.save") }}</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-card-actions id="pCardAct">
              <v-fab-transition>
                <v-btn
                  id="btnAddlocalInstallation"
                  color="primary"
                  dark
                  small
                  left
                  fab
                  @click="createItem()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card-actions>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import ProjectAsset from '../components/common/ProjectAsset';
import Vue from 'vue';

export default {
  components: {
    "project-asset": ProjectAsset,
  },
  data() {
    return {
     
      dialog: false,
      requiredMessage: this.$t("common.required"),
      headers: [        
        {
          text: this.$t("localInstallation.computerId"),
          align: "left",
          value: "description",
        },        
        {
          text: this.$t("nav.projects"),
          align: "left",
          value: "projectId",
        },
        {
          text: this.$t("nav.vessels"),
          align: "left",
          value: "vesselId",
        },
        { text: this.$t("localInstallation.assignmentStart"), align: "left", value: "assignmentStart" },
        { text: this.$t("localInstallation.assignmentEnd"), align: "left", value: "assignmentEnd" },
        {
          text: this.$t("column.actions"),
          align: "center",
          value: "localInstallationactions",
          sortable: false,
        },
      ],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      selProjectId: 0,
      selVesselId: 0,
      dlgSelProjectId: null
    };
  },
  computed: {
    ...mapGetters([      
      "getComputers",
      "getProjectsInComputer",

      'm_project/getProjectNames',
      'm_project/getProjectsMap',
      'm_project/getProjectVesselIds',

      'm_vessel/getVesselNames',
      'm_vessel/getVesselsMap',

      'm_passet/getSelProjectId',
      'm_passet/getSelVesselId',
      'm_passet/getSelProjectVesselIds'
    
    ]),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("common.new") + " " + this.$t("nav.localInstallation")
        : this.$t("common.edit") + " " + this.$t("nav.localInstallation");
    },
    items() {
      return this.getProjectsInComputer
       .filter(
         (e) =>
          (!this.selProjectId || e.projectId == this.selProjectId) &&
         (!this.selVesselId || e.vesselId == this.selVesselId)
       )
    },

    computers(){
      return this.getComputers;
    },
     projects() {
      return this['m_project/getProjectNames'].filter((p) => p.VCount > 0)
    },

    projectsMap() {
      return this['m_project/getProjectsMap']
    },

    vessels() {
      return this['m_vessel/getVesselNames']
    },

    vesselsMap() {
      return this['m_vessel/getVesselsMap']
    },

    projectVessels() {
      let vessels = this.vessels

      let pvIds = this['m_passet/getSelProjectVesselIds']
      if (this.dlgSelProjectId) {
        pvIds = this['m_project/getProjectVesselIds']
      }

      return vessels.filter((v) => (pvIds || []).indexOf(v.Id) !== -1)
    },

    formIsValid() {
      return (
        this.editedItem.computerId &&
        this.editedItem.vesselId &&
        this.editedItem.projectId
      )
    }

  },

  filters: {
    projectName: function (pId, map) {
      return pId ? map[pId] : ''
    },
    vesselName: function (vId, map) {
      return vId ? map[vId] : ''
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.loadProjectsInComputer();
    this.loadComputers();
    // this.loadProjects();
    // this.loadVessels();

    this.selProjectId = this['m_passet/getSelProjectId']
    this.selVesselId = this['m_passet/getSelVesselId']
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  methods: {
    ...mapMutations(["mHideLongLoader"]),
    ...mapActions([
      "loadProjectsInComputer",
      'm_project/fetchProjectVesselNames',
      "deleteProjectsInComputer",
      "createProjectsInComputer",
      "loadComputers"
    ]),
    onProjectChange(value) {
      this.selProjectId = value;
    },
    onVesselChange(value) {
      this.selVesselId = value;
    },
    
    onDlgProjectChange() {
      this.dlgSelProjectId = this.editedItem.projectId
      Vue.$log.debug('dlg project change', this.dlgSelProjectId)
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)
    },

    resetEntity(item) {
      this.dlgSelProjectId = null
      this['m_project/fetchProjectVesselNames'](this.dlgSelProjectId)

      this.defaultItem.projectId = this['m_passet/getSelProjectId']
      this.defaultItem.vesselId = this['m_passet/getSelVesselId']

      this.editedIndex = item ? this.items.indexOf(item) : -1
      this.editedItem = Object.assign({}, item || this.defaultItem)
    },

    filterArray(array, id) {
      return array.filter((element) => element.id == id);
    },
    
    createItem() {
      this.resetEntity()
      this.onDlgProjectChange()
      this.dialog = true;
    },    
    deleteItemConfirm(item) {
      this.resetEntity(item);      
      var msg = 'warning.remove';      
      this.$confirm(this.$t(msg) + this.$t('nav.localInstallation') + '?', {
        buttonTrueText: this.$t('common.ok'),
        buttonFalseText: this.$t('common.cancel'),
        color: 'warning',
        icon: 'warning',
        title: this.$t('common.warning'),
        width: 350,
        property: '$confirm'
      }).then((res) => res && this.deleteProjectsInComputer(this.editedItem))
    },
    close() {
      this.$refs.form.resetValidation()
      this.dialog = false;      
    },
    
    save() {
      let data = {
        computerId: this.editedItem.computerId,
        projectId: this.editedItem.projectId,
        vesselId: this.editedItem.vesselId,
        asignmentStart: this.editedItem.asignmentStart,
        asignmentEnd: this.editedItem.asignmentEnd,
      }

      if (~this.editedIndex) {
        data.id = this.editedItem.id
        this.updateProjectsInComputer({ model: data })
      }

      if (!~this.editedIndex) {
        this.createProjectsInComputer({ model: data })
      }

      this.close()
    }
  },
};
</script>

<style>
#localInstallationTable {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  margin-top: 20px;
  width: auto;
  height: auto;
}
#localInstallationTable header {
  font-weight: bold;
}
#localInstallationCard {
  width: auto;
}
</style>